import { ChangeDetectionStrategy, Component, ElementRef, ViewEncapsulation } from '@angular/core';
import { AuthenticateService } from '@fi-app/utilities/fi-services/authenticate.service';
import { AppTextService } from '@fi-shared/app-text';
import { ErrorMessageService } from '@fi-app/utilities/fi-services/error-message.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FormValidatorService } from '@fi-app/utilities/fi-services/form-validator.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { ReplaySubject } from 'rxjs';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { IFeedbackContactSupport } from '@fi-shared/fi-support/feedback';
import { ContactSupportOptionType } from '@fi-shared/fi-support/fi-contact-support-dialog/fi-contact-support-dialog.component';
import { FiSupportService } from '@fi-shared/fi-support/fi-support.service';

@Component({
    selector: 'fi-authenticate-help-other',
    templateUrl: './help-other.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-authenticate-help-other' },
    styleUrls: ['../authenticate.scss', './help-other.component.scss'],
    standalone: false,
})
export class FiAuthenticateHelpOtherComponent {
    processing$ = new ReplaySubject<boolean>(1);

    UserCredential: IFeedbackContactSupport = {
        UserId: 0,
        UserName: '',
        EmailAddress: '',
        Description: '',
        PhoneNumber: '',
        SupportType: ContactSupportOptionType.Account,
    };

    private readonly descriptionMinLength: number = 20;

    constructor(
        private authenticateService: AuthenticateService,
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
        private errorMessage: ErrorMessageService,
        private stateService: FiStateService,
        private formValidatorService: FormValidatorService,
        private loadingService: LoadingService,
        private elRef: ElementRef,
        private customerDataService: FiCustomerDataService,
        private supportService: FiSupportService,
    ) {}

    Submit($event) {
        $event.preventDefault();

        if (!this.formValidatorService.validateForm(this.elRef.nativeElement.querySelector('[name="Form"]'))) {
            this.formValidatorService.showErrorMessage();
            $event.preventDefault();
            return;
        }

        const emailRegex =
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (
            this.UserCredential.UserName != undefined &&
            this.UserCredential.UserName != '' &&
            this.UserCredential.EmailAddress != undefined &&
            this.UserCredential.EmailAddress != '' &&
            emailRegex.test(this.UserCredential.EmailAddress)
        ) {
            this.processing$.next(true);
            const promise = this.loadingService.trackPromise(
                this.supportService.sendFeedback({
                    attachScreenshot: false,
                    contactSupport: this.UserCredential,
                    files: [],
                }),
            );
            promise.finally(() => this.processing$.next(false));
        } else {
            let messageText;

            if (
                !emailRegex.test(this.UserCredential.EmailAddress) &&
                this.UserCredential.EmailAddress != '' &&
                this.UserCredential.EmailAddress != undefined
            ) {
                messageText = this.appTextService.get('feedback.contact_support_invalid_email');
            } else {
                messageText = this.appTextService.get('feedback.contact_support_invalid_empty_login');
            }

            this.fiDialogsService.error({ messageText });
        }
    }

    getSupportPhoneNumber(): string {
        return this.customerDataService.getSupportPhoneNumber();
    }

    getSupportEmail(): string {
        return this.customerDataService.getSupportEmailAddress();
    }

    getHelpOtherDescriptionMinLength() {
        return this.descriptionMinLength;
    }

    getHelpOtherErrorMessage() {
        return this.appTextService.get('error_message.min_length_error', {
            '{0}': this.descriptionMinLength,
        });
    }
}
